module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/add_medical_leaders/logo2025_tokyo-5f6336e4f0e2be887c3410127975296f.svg";